window._ = require('lodash')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken
}

let sessionRefreshPending = false

window.axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 419 && !sessionRefreshPending) {
            sessionRefreshPending = true

            const notice = document.createElement('div')
            notice.setAttribute('role', 'alert')
            notice.setAttribute('aria-live', 'assertive')
            notice.textContent = 'Votre session a expiré. La page sera actualisée…'
            Object.assign(notice.style, {
                position: 'fixed',
                zIndex: '2147483647',
                right: '1rem',
                bottom: '1rem',
                maxWidth: '24rem',
                padding: '1rem 1.25rem',
                borderRadius: '.5rem',
                background: '#252525',
                color: '#fff',
                boxShadow: '0 8px 24px rgba(0, 0, 0, .24)',
            })
            document.body.appendChild(notice)

            window.setTimeout(() => window.location.reload(), 2000)
        }

        return Promise.reject(error)
    }
)

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
